import { computed } from "vue";

// by convention, composable function names start with "use"
export function useIsLMSView() {
    // TODO: use VueUse for reactivity on localStorage
  const isLMSView = computed(() =>
    JSON.parse(localStorage.getItem("lms") || "false")
  );
  return isLMSView;
}
